// 模拟AI生成诗意文案的服务
export async function generatePoeticCaption(base64Image: string): Promise<string> {
  // 模拟API调用延迟
  await new Promise(resolve => setTimeout(resolve, 1500));
  
  // 返回一些预设的诗意文案
  const poeticCaptions = [
    "时光如水，音符如诗，此刻定格成永恒的美好",
    "镜头捕捉的不只是画面，更是心中那份纯真的感动", 
    "每一个瞬间都值得被珍藏，就像每一首歌都有它的故事",
    "光影交错间，记录下生命中最珍贵的片段",
    "简单的美好，往往最能触动人心的深处",
    "用心感受这个世界，用镜头记录这份温暖"
  ];
  
  return poeticCaptions[Math.floor(Math.random() * poeticCaptions.length)];
}